var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass:
        "select-none transition-bg transition-250 w-full font-bold text-2xl md_text-lg md_font-normal disabled_opacity-50 disabled_cursor-not-allowed",
      class: _vm.classes,
      on: {
        click: function($event) {
          _vm.disabled ? null : _vm.$emit("click")
        }
      }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }